export default __webpack_public_path__ + "static/bigfile-5bbd1cd59f05d1ca0ed6f6ad066f18d3.png";